<template>
  <div class="full-page">
    <!-- 背景图片 -->
    <img :src="Image" alt="背景图" class="full-image" />

    <div class="data-container">
      <!-- 频率数据（基于频率值判断运行状态） -->
      <!--冷冻泵-->
      <span
        class="data-item freq-item"
        style="left: 69.5%; top: 43%;"
        :class="{ 'running': isPumpRunning(feq02) }"
      >
        1#&nbsp;{{ formatFreq(feq02) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 69.5%; top: 54.5%;"
        :class="{ 'running': isPumpRunning(feq02) }"
      >
        2#&nbsp;{{ formatFreq(feq02) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 69.5%; top: 66%;"
        :class="{ 'running': isPumpRunning(feq01) }"
      >
        3#&nbsp;{{ formatFreq(feq01) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 69.5%; top: 78%;"
        :class="{ 'running': isPumpRunning(feq03) }"
      >
        4#&nbsp;{{ formatFreq(feq03) }} Hz
      </span>
      <!--冷却泵-->
      <span
        class="data-item freq-item"
        style="left: 17.5%; top: 43%;"
        :class="{ 'running': isPumpRunning(feq05) }"
      >
        1#&nbsp;{{ formatFreq(feq05) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 17.5%; top: 54.5%;"
        :class="{ 'running': isPumpRunning(feq05) }"
      >
        2#&nbsp;{{ formatFreq(feq05) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 17.5%; top: 66%;"
        :class="{ 'running': isPumpRunning(feq04) }"
      >
        3#&nbsp;{{ formatFreq(feq04) }} Hz
      </span>
      <span
        class="data-item freq-item"
        style="left: 17.5%; top: 78%;"
        :class="{ 'running': isPumpRunning(feq06) }"
      >
        4#&nbsp;{{ formatFreq(feq06) }} Hz
      </span>

      <!-- 消息滚动提示框 -->
<!--      <div class="msg-box">-->
<!--        <div class="msg-scroll" :style="{ transform: `translateY(-${scrollOffset}px)` }">-->
<!--          <div-->
<!--            class="msg-item"-->
<!--            v-for="(msg, idx) in infiniteMsgList"-->
<!--            :key="idx"-->
<!--            :class="{-->
<!--              'msg-running': msg.includes('正在运行'),-->
<!--              'msg-stopped': msg.includes('未开机')-->
<!--            }"-->
<!--          >-->
<!--            {{ msg }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 机组名称（动态颜色） -->
      <span
        class="data-item jz-number"
        style="left: 44.5%; top: 44.5%;"
        :style="{ color: Number(JZ_status) === 1 ? '#00cc00' : 'black' }"
      >
        1#
      </span>
      <span
        class="data-item jz-number"
        style="left: 44.5%; top: 60.8%;"
        :style="{ color: Number(JZ_status1) === 1 ? '#00cc00' : 'black' }"
      >
        2#
      </span>
      <span
        class="data-item jz-number"
        style="left: 44.5%; top: 77.2%;"
        :style="{ color: Number(JZ_status2) === 1 ? '#00cc00' : 'black' }"
      >
        3#
      </span>

      <!-- 机组状态（动态修改内容、颜色、居中） -->
      <span
        class="data-item jz-status"
        style="left: 43%; top: 49.5%;"
        :style="{ color: Number(JZ_status) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
      >
        {{ Number(JZ_status) === 1 ? '正在运行中' : '螺杆机组' }}
      </span>
      <span
        class="data-item jz-status"
        style="left: 43%; top: 65.8%;"
        :style="{ color: Number(JZ_status1) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
      >
        {{ Number(JZ_status1) === 1 ? '正在运行中' : '离心机组' }}
      </span>
      <span
        class="data-item jz-status"
        style="left: 43%; top: 82%;"
        :style="{ color: Number(JZ_status2) === 1 ? '#00cc00' : 'black', textAlign: 'center' }"
      >
        {{ Number(JZ_status2) === 1 ? '正在运行中' : '离心机组' }}
      </span>

      <!-- 温度数据 -->
      <span class="data-item" style="left: 52%; top: 46%;">&nbsp;NaN °C</span>
      <span class="data-item" style="left: 52%; top: 49.3%;">&nbsp;NaN °C</span>
      <span class="data-item" style="left: 35%; top: 46%;">&nbsp;NaN °C</span>
      <span class="data-item" style="left: 35%; top: 49.3%;">&nbsp;NaN °C</span>

      <span class="data-item" style="left: 52%; top: 63%;">&nbsp;{{ C2_EvapIn }} °C</span>
      <span class="data-item" style="left: 52%; top: 65.7%;">&nbsp;{{ C2_EvapOut }} °C</span>
      <span class="data-item" style="left: 35%; top: 63%;">&nbsp;{{ C2_CondIn }} °C</span>
      <span class="data-item" style="left: 35%; top: 65.7%;">&nbsp;{{ C2_CondOut }} °C</span>

      <span class="data-item" style="left: 52%; top: 82%;">&nbsp;{{ C3_EvapIn }} °C</span>
      <span class="data-item" style="left: 52%; top: 84.5%;">&nbsp;{{ C3_EvapOut }} °C</span>
      <span class="data-item" style="left: 35%; top: 82%;">&nbsp;{{ C3_CondIn }} °C</span>
      <span class="data-item" style="left: 35%; top: 84.5%;">&nbsp;{{ C3_CondOut }} °C</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HLSWMonitor',
  data() {
    return {
      Image: 'https://hpc.cnhopo.com/hpcimgs/20260623_dad97e12_HLSW2.png',
      timer: null,
      scrollTimer: null,
      cookieValue: '',

      // 75KW接触器信号
      Freeze_1:'',
      Freeze_2:'',
      Cooling_1:'',
      Cooling_2:'',

      // 频率/温度数据
      feq01: '', feq02: '', feq03: '', feq04: '', feq05: '', feq06: '',
      C1_EvapIn: '', C1_EvapOut: '', C1_CondIn: '', C1_CondOut: '',
      C2_EvapIn: '', C2_EvapOut: '', C2_CondIn: '', C2_CondOut: '',
      C3_EvapIn: '', C3_EvapOut: '', C3_CondIn: '', C3_CondOut: '',

      // 机组状态存储
      JZ_status: '',   // 1#机组状态
      JZ_status1: '',  // 2#机组状态
      JZ_status2: '',  // 3#机组状态

      // 消息滚动配置
      baseMsgList: [],
      infiniteMsgList: [],
      scrollOffset: 0,
      itemHeight: 24,
      showCount: 5
    }
  },
  created() {
    this.infiniteMsgList = [...this.baseMsgList];
    const userStr = localStorage.getItem("user") || '{}';
    const userObj = JSON.parse(userStr);
    this.cookieValue = userObj.cookie || '';
    console.log("HLSW页面的原始user数据：", userStr);
    console.log("提取出的cookie值：", this.cookieValue);
  },
  mounted() {
    this.dsfzdata();
    this.startTimer();
    this.startMsgScroll();
  },
  destroyed() {
    this.clearTimer();
    this.clearMsgScroll();
  },
  methods: {
    // 格式化频率值：小于0显示NaN，等于0显示0，大于0正常显示
    formatFreq(value) {
      if (value === '' || value === null || value === undefined || isNaN(Number(value))) {
        return 'NaN';
      }
      const num = Number(value);
      if (num < 0) {
        return 'NaN';
      }
      if (num === 0) {
        return '0';
      }
      return Math.floor(num);
    },

    // 判断泵是否运行：值大于0视为运行
    isPumpRunning(value) {
      if (value === '' || value === null || value === undefined || isNaN(Number(value))) {
        return false;
      }
      const num = Number(value);
      return num > 0;
    },

    startTimer() {
      this.timer = setInterval(() => {
        this.dsfzdata();
      }, 20000);
    },
    clearTimer() {
      if (this.timer) clearInterval(this.timer);
    },
    startMsgScroll() {
      this.scrollTimer = setInterval(() => {
        this.scrollOffset += this.itemHeight;
        const singleListHeight = this.baseMsgList.length * this.itemHeight;
        if (singleListHeight > 0 && this.scrollOffset >= singleListHeight) {
          this.scrollOffset = this.scrollOffset - singleListHeight;
        }
      }, 4000);
    },
    clearMsgScroll() {
      if (this.scrollTimer) clearInterval(this.scrollTimer);
    },

    // 生成消息列表（仅基于机组状态）
    generateMsgList() {
      const jzMsg = [
        `1#机组${Number(this.JZ_status) === 1 ? '正在运行' : '未开机'}`,
        `2#机组${Number(this.JZ_status1) === 1 ? '正在运行' : '未开机'}`,
        `3#机组${Number(this.JZ_status2) === 1 ? '正在运行' : '未开机'}`,
      ];

      this.baseMsgList = [...jzMsg];
      this.infiniteMsgList = [...this.baseMsgList, ...this.baseMsgList, ...this.baseMsgList];
    },

    // 机组数据请求
    dsfzdata() {
      fetch("https://hpc.cnhopo.com/otherApi/data/get_hlsw02_data", {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => res.json())
        .then(res => {
          console.log("机组数据", res)
          if (res.code === 200) {
            const data = res.data || {};

            // 75KW接触器信号
            this.Freeze_1 = data.Freeze_1;
            this.Freeze_2 = data.Freeze_2;
            this.Cooling_1 = data.Cooling_1;
            this.Cooling_2 = data.Cooling_2;

            // 频率数据
            this.feq01 = data.feq01 || '';
            this.feq02 = data.feq02 || '';
            this.feq03 = data.feq03 || '';
            this.feq04 = data.feq04 || '';
            this.feq05 = data.feq05 || '';
            this.feq06 = data.feq06 || '';

            // 温度数据处理函数（值小于等于0时返回'NaN'）
            const formatTemp = (value) => {
              if (value === '' || value === null || value === undefined) {
                return 'NaN';
              }
              const num = Number(value);
              if (isNaN(num) || num <= 0) {
                return 'NaN';
              }
              return String(num);
            };

            // 温度数据
            this.C2_EvapIn = formatTemp(data.C2_EvapIn);
            this.C2_EvapOut = formatTemp(data.C2_EvapOut);
            this.C2_CondIn = formatTemp(data.C2_CondIn);
            this.C2_CondOut = formatTemp(data.C2_CondOut);
            this.C3_EvapIn = formatTemp(data.C3_EvapIn);
            this.C3_EvapOut = formatTemp(data.C3_EvapOut);
            this.C3_CondIn = formatTemp(data.C3_CondIn);
            this.C3_CondOut = formatTemp(data.C3_CondOut);

            // 机组状态数据
            this.JZ_status = data.JZ_status || '';
            this.JZ_status1 = data.JZ_status1 || '';
            this.JZ_status2 = data.JZ_status2 || '';

            this.generateMsgList();
          } else {
            alert('机组数据获取失败');
          }
        })
        .catch(err => {
          console.error('机组数据请求失败:', err);
          alert('机组数据网络错误');
        })
    }
  }
}
</script>

<style scoped>
.full-page {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 999;
  overflow: hidden;
}
.full-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: block;
  margin: 0;
  padding: 0;
  z-index: 1;
  object-fit: fill;
}
.data-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}
.data-item {
  position: absolute;
  padding: 5px 10px;
  color: black;
  border-radius: 4px;
  font-weight: bold;
  font-size: 13px;
}

/* 泵频率运行状态样式 - 值大于0时显示绿色 */
.freq-item.running {
  color: #00cc00 !important;
}

/* 机组编号样式 */
.jz-number {
  display: inline-block;
  width: 40px;
  text-align: center;
  box-sizing: border-box;
}

/* 机组状态样式 */
.jz-status {
  display: inline-block;
  width: 90px;
  box-sizing: border-box;
}

/* 消息框样式 */
.msg-box {
  position: absolute;
  left: 66%;
  top: 25.5%;
  width: 280px;
  height: 120px;
  overflow: hidden;
  z-index: 3;
  text-align: left;
}
.msg-scroll {
  transition: transform 0.6s ease-out;
  will-change: transform;
}
.msg-item {
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  margin: 0;
  padding: 0 10px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
}
.msg-running {
  color: #00cc00;
}
.msg-stopped {
  color: #ff0000;
}
.msg-item:not(.msg-running):not(.msg-stopped) {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Hlsw2.vue